import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'btnfinish',
  templateUrl: './btnfinish.component.html',
  styleUrls: ['./btnfinish.component.css']
})
export class BtnfinishComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
